var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarStep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73333 3.13333C3.21787 3.13333 2.8 3.5512 2.8 4.06667V13.4C2.8 13.9155 3.21787 14.3333 3.73333 14.3333H13.0667C13.5821 14.3333 14 13.9155 14 13.4V4.06667C14 3.5512 13.5821 3.13333 13.0667 3.13333H3.73333ZM2 4.06667C2 3.10937 2.77604 2.33333 3.73333 2.33333H13.0667C14.024 2.33333 14.8 3.10937 14.8 4.06667V13.4C14.8 14.3573 14.024 15.1333 13.0667 15.1333H3.73333C2.77604 15.1333 2 14.3573 2 13.4V4.06667Z",
    fill: "#041C32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0667 1C11.2876 1 11.4667 1.17909 11.4667 1.4V4.06667C11.4667 4.28758 11.2876 4.46667 11.0667 4.46667C10.8458 4.46667 10.6667 4.28758 10.6667 4.06667V1.4C10.6667 1.17909 10.8458 1 11.0667 1Z",
    fill: "#041C32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73334 1C5.95425 1 6.13334 1.17909 6.13334 1.4V4.06667C6.13334 4.28758 5.95425 4.46667 5.73334 4.46667C5.51242 4.46667 5.33334 4.28758 5.33334 4.06667V1.4C5.33334 1.17909 5.51242 1 5.73334 1Z",
    fill: "#041C32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.73333C2 6.51242 2.17909 6.33333 2.4 6.33333H14.4C14.6209 6.33333 14.8 6.51242 14.8 6.73333C14.8 6.95425 14.6209 7.13333 14.4 7.13333H2.4C2.17909 7.13333 2 6.95425 2 6.73333Z",
    fill: "#041C32"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarStep);
export default __webpack_public_path__ + "static/media/calendar-step.b28e7190a0fa5c10d0084a630d742b90.svg";
export { ForwardRef as ReactComponent };